var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStreamlineIconColorPaintingPalette(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.92 11.24a12.33 12.33 0 0 0-9-10.37 9.82 9.82 0 0 0-5.78 0A12.47 12.47 0 0 0 .36 9.75a11.88 11.88 0 0 0 3.16 11.38 2.5 2.5 0 0 0 3.08.36 1.5 1.5 0 0 0 .26-2.33l-.81-.81a1 1 0 0 1 0-1.42 1.1 1.1 0 0 1 1.6-.19c1.41 1.41 5.62 5.66 5.62 5.66a4 4 0 0 0 2.82 1.18 3.68 3.68 0 0 0 1.91-.53 12 12 0 0 0 5.92-11.81Zm-9.44 7.62a2.49 2.49 0 0 1 0-3.53 2.54 2.54 0 0 1 3.53 0 2.5 2.5 0 0 1-3.53 3.53ZM14.25 7.2a2 2 0 0 1 2-2 2 2 0 1 1-2 2Zm3.69 6a1.5 1.5 0 0 1 2.12-2.12 1.5 1.5 0 1 1-2.12 2.12Zm-6.29-8.48a2 2 0 1 1-2.83 0 2 2 0 0 1 2.83 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamlineIconColorPaintingPalette);
export default __webpack_public_path__ + "static/media/streamline-icon-color-painting-palette.9ef67d01.svg";
export { ForwardRef as ReactComponent };